var render = function render(){var _vm=this,_c=_vm._self._c;return _c('divBox',{staticClass:"dayTimeBox",attrs:{"title":'日告警数量'}},[_c('Chart',{attrs:{"cdata":_vm.cdata,"width":'450',"height":'390'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }